import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./ItensEstabelecimento.module.css";
import SecaoItens from '../components/SecaoItens';
import Search from "../components/Search";
import FooterOpcoes from "../components/FooterOpcoes";
import { EstabelecimentosContext } from "../../../shared/contexts/EstabelecimentosContext";
import { CategoriasContext } from "../../../shared/contexts/CategoriasContext";
import CarrinhoIcon from "../components/CarrinhoIcon";

function ItensEstabelecimento() {
  const { id } = useParams();
  const { estabelecimentos, loading, fetchEstabelecimentos } = useContext(EstabelecimentosContext);

  useEffect(() => {
    fetchEstabelecimentos();
  }, []);
  const { categorias } = useContext(CategoriasContext);
  const [textoFiltro, setTextoFiltro] = useState("");
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);

  // Encontrar o estabelecimento pelo id da URL
  const estabelecimento = estabelecimentos.find(
    (e) => e.id_estabelecimento === Number(id)
  );

  // Guarda o contexto do estabelecimento visitado (ex: via QR code) pra saber,
  // se o cliente for se cadastrar, se é um estabelecimento vinculado a
  // universidade (UniEat) ou um restaurante avulso (EatOrder, sem universidade).
  useEffect(() => {
    if (estabelecimento) {
      localStorage.setItem('estabelecimento_contexto_id', estabelecimento.id_estabelecimento);
      localStorage.setItem('estabelecimento_contexto_universidade', estabelecimento.id_universidade || '');
    }
  }, [estabelecimento]);

  // Garante que seja array
  const categoriasArray = Array.isArray(categorias) ? categorias : [];

  if (loading) {
    return <p className={styles.loading}>Carregando estabelecimento...</p>;
  }

  if (!estabelecimento) {
    return <p className={styles.loading}>Estabelecimento não encontrado.</p>;
  }

  return (
    <div className={styles.container}>
      {/* Ícone do Carrinho */}
      <div className={styles.carrinhoIconContainer}>
        <CarrinhoIcon />
      </div>

      {/* Header com logo */}
      <div className={styles.headerEstabelecimento}>
        <div className={styles.logoCircular}>
          {estabelecimento.logo ? (
            <img
              src={`${process.env.REACT_APP_API_URL}${estabelecimento.logo}`}
              alt={estabelecimento.nomeEstabelecimento}
            />
          ) : (
            <span className={styles.logoFallback}>
              {estabelecimento.nomeEstabelecimento?.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        <div className={styles.headerInfo}>
          <h1 className={styles.nomeEstabelecimento}>
            {estabelecimento.nomeEstabelecimento}
          </h1>

          {(() => {
            let fechado = false;
            if (estabelecimento.fechamento_manual) {
              fechado = true;
            } else if (estabelecimento.hora_abertura && estabelecimento.hora_fechamento) {
              const agora = new Date();
              const horaAtual = agora.getHours().toString().padStart(2, '0') + ':' + agora.getMinutes().toString().padStart(2, '0');
              const abertura = estabelecimento.hora_abertura.substring(0, 5);
              const fechamento = estabelecimento.hora_fechamento.substring(0, 5);
              fechado = horaAtual < abertura || horaAtual >= fechamento;
            }
            return (
              <div className={styles.statusRow}>
                <span className={fechado ? styles.statusFechado : styles.statusAberto}>
                  <span className={styles.statusDot} />
                  {fechado ? "Fechado" : "Aberto agora"}
                </span>
                {estabelecimento.hora_abertura && estabelecimento.hora_fechamento && (
                  <span className={styles.horarioFuncionamento}>
                    · {estabelecimento.hora_abertura.substring(0, 5)} às {estabelecimento.hora_fechamento.substring(0, 5)}
                  </span>
                )}
              </div>
            );
          })()}
        </div>
      </div>

      {/* Seção de busca + filtros por categoria */}
      <div className={styles.filtrosSection}>
        <Search onSetFiltroTexto={setTextoFiltro} noBorder />
        <div className={styles.categoriasScroll}>
          <button
            className={`${styles.categoriaBtn} ${!categoriaSelecionada ? styles.categoriaAtiva : ''}`}
            onClick={() => setCategoriaSelecionada(null)}
          >
            Todos
          </button>
          {categoriasArray.map((categoria) => (
            <button
              key={categoria.id_categoria}
              className={`${styles.categoriaBtn} ${categoriaSelecionada === categoria.nome_categoria ? styles.categoriaAtiva : ''}`}
              onClick={() => setCategoriaSelecionada(categoria.nome_categoria)}
            >
              {categoria.nome_categoria}
            </button>
          ))}
        </div>
      </div>

      {/* Seção de itens */}
      <div className={styles.secaoItens}>
        <SecaoItens
          idEstabelecimento={id}
          textoFiltrado={textoFiltro}
          categoriaSelecionada={categoriaSelecionada}
        />
      </div>

      <FooterOpcoes typeView={"cliente"}/>
    </div>
  );
}

export default ItensEstabelecimento;
